import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { acquirePushSaleItem } from '../../services/PushSales'

import { getQueryStringParams } from '../../utils/utils'

import Loading from '../../components/Loading'

function PushSalesPage(props) {
  const { t, i18n } = useTranslation()

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [submitSale, setSubmitSale] = useState(false)

  useEffect(() => {
    const queryStringValues = getQueryStringParams(
      props.location && props.location.search ? props.location.search : null
    )
    const lang = queryStringValues.lang || 'en'
    i18n.changeLanguage(lang)

    setSubmitSale(true)
  }, [props.location])

  useEffect(() => {
    if (submitSale) {
      const token = props.match?.params?.token
      setLoading(true)
      acquirePushSaleItem(token)
        .then(res => {
          setLoading(false)
        })
        .catch(err => {
          setLoading(false)
          setError(true)
        })
    }

  }, [submitSale, setLoading, setError, props.match])

  const notificationMessage = error ? t('productsNotAcquired') : t('productsAcquired')

  return loading ?
    <Loading active={true} message={t('addingProductsToReservation')} />
    : (
      <div className="container light-green-bg">
        <div className="row justify-content-center text-center">
          <div className="col-5 mt-5">
            <div>
              <img onClick={() => props.history.push('/start')} src={require(`../../assets/images/logo.png`)} alt="Guerin" className="img-fluid pt-3 pb-3" />
            </div>
          </div>
        </div>
        <div className="text-center light-green-bg">
          <div className="resumo-header">
            <h2 className="title"><b>{t('thankYouForYourPreference')}</b></h2>
            <p className="p-4 color-grey font-weight-light">{notificationMessage}</p>
          </div>
        </div>
      </div>
    )
}

export default PushSalesPage
export const PATH = '/push-sales/:token'